import { buildRoute } from '../utils/routes';
import { push, replace } from 'redux-first-history';

import { DEVICE_MODEL_SELECTED } from './index';

export default function selectDeviceModel(
  model,
  modelNumber,
  singleModelOptionAvailable = false
) {
  return (dispatch, getState) => {
    const {
      group: { configurableFields = [], slug },
      contact: { customerDetailsPreloaded },
    } = getState();

    dispatch({ type: DEVICE_MODEL_SELECTED, model, modelNumber });
    if (customerDetailsPreloaded) {
      // If customer details are preloaded we don't want to push a new route...
      // we want to allow the customer to confirm their details first.
      return;
    }

    let nextRoute = '';
    if (model.colors.length) {
      nextRoute = 'color';
    } else if (configurableFields.length) {
      nextRoute = 'configurable-fields';
    } else {
      nextRoute = 'issue';
    }
    if (singleModelOptionAvailable) {
      dispatch(replace(buildRoute(slug, nextRoute)));
    } else {
      dispatch(push(buildRoute(slug, nextRoute)));
    }
  };
}
